module.exports = __webpack_public_path__ + "img/progresando-peru.f064129a.png";